import React from 'react';
import AdContainer from '../../ads';
import { AdItem } from '../styles';

const CategoryItemAd = () => {
  return (
    <AdItem $hasChildren={false}>
      <AdContainer
        onlyWithServices={['appnexus']}
        placement="dubbelpanorama1"
        format="panorama_1"
        min={0}
        max={860}
        spacing={{ bottom: '20px' }}
      />
    </AdItem>
  );
};

export default CategoryItemAd;
